import { Component, Input, inject } from '@angular/core';
import { FormattedContentDirective } from 'directives/formatted-content.directive';
import { ReplyType } from 'enums/ReplyType';
import { ApprovalStatus, InputTypeApprovalModel } from 'models/generated/Models.InputTypeData.InputTypeApproval';
import { TranslatePipe } from 'pipes/translate.pipe';


@Component({
	selector: 'questionnaire-reply',
	templateUrl: './questionnaire-reply.component.html',
	imports: [FormattedContentDirective, TranslatePipe]
})
export class QuestionnaireReplyComponent {
	@Input() reply?: unknown;
	@Input() replyType!: ReplyType;
	replyTypeEnum = ReplyType;
	approvalStatusEnum = ApprovalStatus;

	private readonly translate = inject(TranslatePipe);

	get approval(): InputTypeApprovalModel | null {
		if (!this.reply || this.replyType != ReplyType.Approval && this.reply === null) return null;
		return this.reply as InputTypeApprovalModel;
	}

	get formattedReply(): string | undefined {

		if (this.reply === undefined || this.reply === null) return undefined;

		switch (this.replyType) {
			
			case ReplyType.Approval:
				return this.reply != null ? this.approval?.comment : '';

			case ReplyType.TrueFalse:
				return this.translate.transform(`general.${this.reply}`);

			case ReplyType.AddMultiple:
				const stringArray = this.reply as string[];
				return stringArray && stringArray.join ? stringArray.join(', ') : '';

			default:
				return this.reply as string;
		}
	}
}
